import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AiAssistantService } from 'modules/cms/seo/ai-assistant/services';
import { AI_ASSISTANTS_LIST_KEY } from 'modules/cms/seo/ai-assistant/constants';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export const useDeleteAiAssistant = (id: string, onClose: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('aiAssistant');
  return useMutation(() => AiAssistantService.delete(id), {
    onSuccess: (data) => {
      toast.success(t('successDeleted'));
      onClose?.();
      queryClient.invalidateQueries({ queryKey: [AI_ASSISTANTS_LIST_KEY] });
      queryClient.invalidateQueries({ queryKey: [id] });
    },
  });
};
